import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ScenarioList.css';
import { SCENARIOS } from './scenarioScreens';
import { scenarioPath } from './scenes';

/**
 * What there is to play. Picking one goes through its door, which is what starts a run of it.
 *
 * A bare list: what the app plays, in the order it plays them. Nothing is said here about the
 * language a scenario is played in.
 */
export default function ScenarioList() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="chat-list-container">
      <div className="chat-list-header">
        <h2>{t('scenarioList.title')}</h2>
      </div>
      <div className="chat-list-content">
        <ul className="chat-list" aria-label={t('scenarioList.title')}>
          {SCENARIOS.map(({ key, screen }) => (
            <li key={key} className="chat-list-item scenario-list-item">
              {/* A button rather than a clickable row: this is the one control on the screen,
                  and it has to be reachable from the keyboard. */}
              <button type="button" onClick={() => navigate(scenarioPath(key))}>
                <span className="chat-list-item-name">{t(screen.title)}</span>
                <span className="scenario-list-item-subtitle">{t(screen.subtitle)}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
